import { TemplateRef } from '@angular/core';

export enum TableColumnHeaderType {
  CUSTOM = 'custom'
}

export enum TableColumnType {
  CURRENCY = 'currency',
  CUSTOM = 'custom',
  TEXT = 'text',
}

export interface TableTemplateContext {
  /**
   * @todo: Change row type to more TS oriented for both properties
   */
  $implicit: any;
  data: any;
}

export interface TableColumn<TNames = string> {
  label: string;
  name: TNames;
  type?: TableColumnType;
  headerType?: TableColumnHeaderType;
  headerClass?: string;
  cellClass?: string;
  value?: string | Function;
  hidden?: boolean;
}

export interface TemplatesMap {
  [name: string]: TemplateRef<TableTemplateContext>;
}
